import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import TaskList from './TaskList';
import AssistantTasks from './AssistantTasks';
import { useAppSelector } from '../../hooks';
import { isAks2talOnly } from '../../components/AdminOnly';
import { fetchTasks } from '../../modules/tasks/actions';

class TaskListContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      issues: [],
    };
  }

  componentDidMount() {
    const self = this;
    const { userId } = this.props;
    this.props.fetchTasks({ userId });
  }
  render() {
    return <TaskList {...this.props} />;
  }
}

function mapStateToProps(state) {
  return {
    tasks: state.tasks.tasks,
    userId: state.user.details.uid,
    loading: state.tasks.loading,
  };
}

const mapActionsToProps = {
  fetchTasks,
};

const withConnect = connect(mapStateToProps, mapActionsToProps);

const LegacyTasks = compose(withConnect, withRouter)(TaskListContainer);
export default function TasksContainer(props) {
  const uid = useAppSelector((state) => state.user.details.uid);
  const location = useLocation();
  const assistantView = new URLSearchParams(location.search).get('view') === 'assistant';
  return isAks2talOnly(uid) && assistantView ? (
    <AssistantTasks key={uid} />
  ) : (
    <LegacyTasks {...props} />
  );
}
